import styled from 'styled-components'

const GenericMainCard = styled.div`
  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'unset')};
  height: ${(props) => (props.height ? props.height : 'unset')};
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'unset')};
  min-height: ${(props) => (props.minHeight ? props.minHeight : 'unset')};
  display: flex;
  flex-direction: ${(props) => (props.flexDir ? props.flexDir : 'row')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.align ? props.align : 'center')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  border-radius: 30px;
  padding: ${(props) => (props.padding ? props.padding : '3%')};
  box-sizing: border-box;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  opacity: ${(props) => (props.opacity ? props.opacity : 'unset')};

  input[type='text'] {
    cursor: text;
  }

  box-shadow: 0 2.5px 3.1px rgba(0, 0, 0, 0.048),
    0 6.1px 7.4px rgba(0, 0, 0, 0.069), 0 11.4px 13.9px rgba(0, 0, 0, 0.085),
    0 20.3px 24.8px rgba(0, 0, 0, 0.101), 0 38px 46.4px rgba(0, 0, 0, 0.122),
    0 91px 111px rgba(0, 0, 0, 0.17);

  &.promo-modal {
    background-color: #342152;
    padding: 7% 11%;
    box-sizing: border-box;
  }
  &.standard {
    background: rgb(114, 143, 251);
    background: linear-gradient(
      90deg,
      rgba(114, 143, 251, 1) 0%,
      rgba(232, 150, 177, 1) 100%
    );
  }

  &.login-mode {
    z-index: 5;
  }

  &.login-mode-card {
    &.mobile-login {
      @media only screen and (max-device-width: 1000px) {
        position: absolute;
        top: 35%;
        height: max-content;
      }
    }

    @media (min-width: 1024px) and (max-width: 1280px) {
      width: 40%;
    }

    @media (min-width: 768px) and (max-width: 1023px) {
      width: 70%;
    }
  }

  &.no-padding {
    padding: 0;
  }

  &.photomode-mobile-card {
    min-height: 65vh;
  }

  &.select-training-day {
    min-height: 75vh;
  }
`

export default GenericMainCard
